import React from 'react'
import {PageWrap} from "../../Components";
import ApprovalDetail from "../../Containers/Vacation/ApprovalDetail";

const VacationApprovalDetailPage = () => (
    <PageWrap>
        <ApprovalDetail/>
    </PageWrap>
)

export default VacationApprovalDetailPage
